import { faFileAlt, faPencilAlt, faCheck, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./interfaces";
import { RootContainer, File, Container } from "./styles";
import { fileSize } from "./utils";
import useAuthorization from "../../../custom-hooks/useAuthorization/useAuthorization";
import { AUTHORIZATIONS } from "../../../utils/constants/authorization-constants";
import { getFileExtension, getFileNameWithoutExtension } from "../../../utils/files-utils/get-file-extension";

const NewFile = ({ file, fileName, handleChangeFileName, handleRemoveFile }: Props) => {
  const { t } = useTranslation();

  const allowUpload = useAuthorization([AUTHORIZATIONS.LegalEntityAccess.UploadDocuments]);

  const extension = getFileExtension(file.name);
  const fileNameWithoutExtension = getFileNameWithoutExtension(fileName);
  const [editMode, setEditMode] = useState<boolean>(false);

  return (
    <RootContainer>
      <Container>
        <FontAwesomeIcon icon={faFileAlt} />
        <File>
          {editMode ? (
            <TextField
              fullWidth
              value={fileNameWithoutExtension}
              label={`${t("components.upload_document.new_file.label")}`}
              onKeyUp={(e) => {
                if (e.key === "Enter" && fileName) setEditMode(false);
              }}
              onChange={(e) => handleChangeFileName && handleChangeFileName(e.target.value.trim())}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    variant="filled"
                  >
                    {`.${extension}`}
                  </InputAdornment>
                ),
              }}
            />
          ) : (
            <Typography>{`${fileNameWithoutExtension}.${extension}`}</Typography>
          )}
        </File>

        {!!handleChangeFileName && (
          <IconButton onClick={() => setEditMode((editMode) => !editMode)}>
            <FontAwesomeIcon icon={editMode ? faCheck : faPencilAlt} />
          </IconButton>
        )}
      </Container>

      <Container>
        <Typography>
          {`${t("components.upload_document.new_file.size")}: 
              ${fileSize(file.size)}`}
        </Typography>
        {allowUpload && (
          <IconButton onClick={handleRemoveFile}>
            <FontAwesomeIcon icon={faTrash} />
          </IconButton>
        )}
      </Container>
    </RootContainer>
  );
};

export default NewFile;
